module.exports = __webpack_public_path__ + "static/nen-eb03644a2e1d004de618c7bfe25e2f46.jpg";